export default __webpack_public_path__ + "static/media/Kraken.da6f5404.png";